import { render, staticRenderFns } from "./ExemplaryCase.vue?vue&type=template&id=a2cce68a&scoped=true&"
import script from "./ExemplaryCase.vue?vue&type=script&lang=js&"
export * from "./ExemplaryCase.vue?vue&type=script&lang=js&"
import style0 from "./ExemplaryCase.vue?vue&type=style&index=0&id=a2cce68a&scoped=true&lang=css&"
import style1 from "./ExemplaryCase.vue?vue&type=style&index=1&id=a2cce68a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cce68a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\001.src\\003.aikl_wrokspace\\aikl_v2_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2cce68a')) {
      api.createRecord('a2cce68a', component.options)
    } else {
      api.reload('a2cce68a', component.options)
    }
    module.hot.accept("./ExemplaryCase.vue?vue&type=template&id=a2cce68a&scoped=true&", function () {
      api.rerender('a2cce68a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/biz/ExemplaryCase.vue"
export default component.exports